import React from 'react';

const ArStep2_1 = ({ ...props }) => {
  return (
    <svg
      {...props}
      width="260"
      height="183"
      viewBox="0 0 256 183"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="31" cy="21" r="17" fill="#ADB5BD" />
      <path
        d="M26.5076 44.5509C26.0669 37.8002 17.2538 36 15.0505 36C2.68245 36 1.39803 45.8397 0.517044 52.5889L0.508829 52.6518C-0.372488 59.4026 0.0681701 81.905 0.508829 88.2057C0.949487 94.5064 1.39015 94.9564 4.47476 99.4569C7.55936 103.957 8.44068 121.959 8.88134 130.96C9.322 139.961 7.1186 152.113 6.23729 154.813C5.35597 157.513 0.0680687 175.065 13.2878 175.965C26.5076 176.865 28.7109 160.214 27.8296 130.96C26.9482 101.707 21.6603 99.4569 24.7449 96.3066C27.8296 93.1562 26.5076 82.8863 26.5076 77.8546V54.9021C26.5076 53.1019 26.9482 51.3017 26.5076 44.5509Z"
        fill="#ADB5BD"
      />
      <mask
        id="mask0_687_6585"
        maskUnits="userSpaceOnUse"
        x="0"
        y="36"
        width="28"
        height="140"
      >
        <path
          d="M26.5076 44.5509C26.0669 37.8002 17.2538 36 15.0505 36C2.68245 36 1.39803 45.8397 0.517044 52.5889L0.508829 52.6518C-0.372488 59.4026 0.0681701 81.905 0.508829 88.2057C0.949487 94.5064 1.39015 94.9564 4.47476 99.4569C7.55936 103.957 8.44068 121.959 8.88134 130.96C9.322 139.961 7.1186 152.113 6.23729 154.813C5.35597 157.513 0.0680687 175.065 13.2878 175.965C26.5076 176.865 28.7109 160.214 27.8296 130.96C26.9482 101.707 21.6603 99.4569 24.7449 96.3066C27.8296 93.1562 26.5076 82.8863 26.5076 77.8546V54.9021C26.5076 53.1019 26.9482 51.3017 26.5076 44.5509Z"
          fill="#ADB5BD"
        />
      </mask>
      <g mask="url(#mask0_687_6585)">
        <path
          d="M11.7881 53.0331L27.5304 73.5233L27.9317 79.929L24.2964 83.584L13.1465 75.3324L10.8012 57.9431L11.7881 53.0331Z"
          fill="url(#paint0_linear_687_6585)"
        />
      </g>
      <rect
        width="18"
        height="4"
        rx="2"
        transform="matrix(0.809185 -0.587554 0.588017 0.808849 61.083 63)"
        fill="#33415C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.9404 76.5843C29.3835 76.2067 28.8812 75.7286 28.4619 75.1545L11.3577 51.7355C9.40333 49.0595 9.99169 45.3105 12.6719 43.3618C15.3521 41.4132 19.1092 42.0028 21.0636 44.6788L36.7235 66.1204L59.1215 59.4889C62.034 58.6266 65.0972 60.2878 65.9631 63.1993C66.829 66.1108 65.1699 69.1701 62.2573 70.0325L35.4094 77.9815C33.4015 78.576 31.3222 77.9712 29.9404 76.5843Z"
        fill="#ADB5BD"
      />
      <line
        x1="38.5"
        y1="176.5"
        x2="249.5"
        y2="176.5"
        stroke="black"
        strokeLinecap="round"
      />
      <path
        d="M38.847 179.384L76.6851 62.5169C77.0938 61.2545 78.5962 60.7328 79.6994 61.4703L254.521 178.337C256.165 179.436 255.387 182 253.409 182H40.7498C39.3919 182 38.4287 180.676 38.847 179.384Z"
        fill="url(#paint1_linear_687_6585)"
        stroke="url(#paint2_linear_687_6585)"
        strokeLinecap="round"
        strokeDasharray="10 10"
      />
      <circle cx="125.5" cy="164.5" r="2.5" fill="#06D6A0" />
      <circle cx="132.5" cy="171.5" r="2.5" fill="#06D6A0" />
      <circle cx="146.5" cy="166.5" r="2.5" fill="#06D6A0" />
      <circle cx="158.5" cy="168.5" r="2.5" fill="#06D6A0" />
      <circle cx="175.5" cy="171.5" r="2.5" fill="#06D6A0" />
      <circle cx="195.5" cy="171.5" r="2.5" fill="#06D6A0" />
      <circle cx="203.5" cy="163.5" r="2.5" fill="#06D6A0" />
      <circle cx="217.5" cy="169.5" r="2.5" fill="#06D6A0" />
      <circle cx="114.5" cy="171.5" r="2.5" fill="#06D6A0" />
      <circle cx="49.5" cy="169.5" r="2.5" fill="#06D6A0" />
      <circle cx="64.5" cy="169.5" r="2.5" fill="#06D6A0" />
      <circle cx="81.5" cy="166.5" r="2.5" fill="#06D6A0" />
      <circle cx="94.5" cy="171.5" r="2.5" fill="#06D6A0" />
      <path
        d="M159.484 86.6328L158.983 86.0559L162.465 81.7126L167.235 84.8102L166.758 85.544L162.657 82.8804L160.238 85.8739C160.48 85.8638 160.796 85.9041 161.184 85.9947C161.579 86.0839 161.976 86.2575 162.373 86.5156C162.797 86.7908 163.135 87.1125 163.386 87.4807C163.645 87.8474 163.811 88.2471 163.884 88.6796C163.96 89.1077 163.942 89.5558 163.831 90.0237C163.722 90.4873 163.513 90.9572 163.204 91.4333C162.906 91.8919 162.576 92.2766 162.212 92.5872C161.849 92.8979 161.458 93.1221 161.039 93.2601C160.624 93.3937 160.185 93.4228 159.725 93.3474C159.265 93.2721 158.788 93.0741 158.294 92.7536C157.914 92.5068 157.59 92.2218 157.322 91.8985C157.061 91.5737 156.87 91.217 156.75 90.8284C156.63 90.4398 156.594 90.0256 156.644 89.5859C156.698 89.1489 156.85 88.6949 157.1 88.2239L157.853 88.7132C157.628 89.1753 157.51 89.6108 157.499 90.0198C157.488 90.4288 157.585 90.8054 157.79 91.1496C157.999 91.4967 158.313 91.8064 158.733 92.0787C159.073 92.3 159.406 92.4383 159.73 92.4936C160.059 92.5518 160.376 92.5313 160.683 92.4323C160.997 92.3317 161.296 92.1569 161.582 91.9079C161.875 91.6573 162.151 91.3333 162.409 90.9358C162.63 90.5951 162.785 90.2516 162.873 89.9052C162.965 89.5545 162.986 89.2112 162.937 88.8752C162.895 88.5376 162.777 88.2219 162.583 87.9281C162.389 87.6343 162.117 87.3739 161.768 87.147C161.313 86.852 160.911 86.6777 160.561 86.6241C160.215 86.5734 159.856 86.5763 159.484 86.6328ZM164.185 96.3925L163.405 95.8861L168.579 87.9188C168.894 87.4339 169.242 87.0794 169.624 86.8552C170.01 86.6339 170.413 86.5387 170.834 86.5698C171.259 86.6036 171.688 86.761 172.12 87.0418C172.255 87.1298 172.39 87.2293 172.522 87.3404C172.658 87.4471 172.779 87.5662 172.886 87.6979L172.398 88.3213C172.308 88.2198 172.21 88.1278 172.102 88.0453C172.001 87.9613 171.877 87.8711 171.728 87.7746C171.444 87.5903 171.16 87.4926 170.875 87.4815C170.593 87.4662 170.324 87.5366 170.067 87.6928C169.81 87.849 169.574 88.0931 169.359 88.4251L164.185 96.3925ZM170.479 90.4009L170.062 91.043L166.419 88.6772L166.836 88.0351L170.479 90.4009ZM174.567 93.056L174.151 93.6981L170.599 91.3919L171.016 90.7498L174.567 93.056ZM173.503 89.775L174.283 90.2814L169.615 97.469C169.402 97.7967 169.286 98.0718 169.265 98.2945C169.245 98.5173 169.286 98.7024 169.389 98.85C169.492 98.9975 169.624 99.1238 169.786 99.2287C169.904 99.3053 170.021 99.3725 170.139 99.4303C170.26 99.4838 170.369 99.5301 170.468 99.5694L170.071 100.252C169.955 100.221 169.815 100.164 169.651 100.082C169.484 100.005 169.324 99.9162 169.171 99.8169C168.869 99.6211 168.638 99.3935 168.478 99.134C168.32 98.8701 168.264 98.5601 168.308 98.2042C168.356 97.8439 168.533 97.4279 168.84 96.9562L173.503 89.775Z"
        fill="#33415C"
      />
      <path
        d="M192.467 119.586L189.852 114.439L186.702 119.277L192.467 119.586ZM125.417 75.9286L128.032 81.076L131.182 76.2377L125.417 75.9286ZM182.683 112.618L175.978 108.253L175.432 109.091L182.137 113.456L182.683 112.618ZM169.273 103.887L162.568 99.5212L162.022 100.359L168.727 104.725L169.273 103.887ZM155.863 95.1555L149.158 90.7897L148.612 91.6277L155.317 95.9935L155.863 95.1555ZM142.453 86.424L135.748 82.0582L135.202 82.8962L141.907 87.262L142.453 86.424Z"
        fill="#33415C"
      />
      <defs>
        <linearGradient
          id="paint0_linear_687_6585"
          x1="19.079"
          y1="55.6675"
          x2="12.4563"
          y2="59.7428"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.107993" stopColor="#33415C" />
          <stop offset="0.89927" stopColor="#C4C4C4" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_687_6585"
          x1="76.0444"
          y1="57.6926"
          x2="89.9919"
          y2="179.299"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#06D6A0" stopOpacity="0.4" />
          <stop offset="1" stopColor="#06D6A0" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_687_6585"
          x1="149"
          y1="55"
          x2="149"
          y2="182"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#06D6A0" />
          <stop offset="1" stopColor="#06D6A0" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ArStep2_1;
